import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from '../ui/SectionHeading';
import { CheckCircle2 } from 'lucide-react';
const targets = [{
  title: 'Esperan su primer hijo',
  desc: 'Esta es la primera vez que viven un embarazo como pareja — sin manual previo.'
}, {
  title: 'Sienten que se están distanciando',
  desc: 'Notan tensión, silencios incómodos o discusiones que antes no tenían.'
}, {
  title: 'Quieren prevenir, no reparar',
  desc: 'Prefieren construir el equipo ahora, antes de que lleguen el cansancio y la falta de sueño.'
}, {
  title: 'Buscan algo concreto, no charlas vagas',
  desc: "Quieren ejercicios, guiones de conversación y rituales semanales — no 'comuníquense más' sin más explicación."
}];
export function ForWhom() {
  return <section className="py-12 md:py-24 px-4 md:px-8 bg-offwhite" data-id="element-121">
      <div className="max-w-5xl mx-auto" data-id="element-122">
        <SectionHeading title="¿PARA QUIÉN ES?" subtitle="Diseñado para ustedes si quieren atravesar el embarazo conectados, no a la deriva" data-id="element-123" />

        <div className="grid md:grid-cols-2 gap-4 md:gap-6 mb-8 md:mb-12" data-id="element-124">
          {targets.map((target, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: i % 2 === 0 ? -20 : 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} whileHover={{
          y: -2
        }} whileTap={{
          scale: 0.98
        }} viewport={{
          once: true
        }} className="bg-cream p-5 md:p-8 rounded-2xl flex gap-3 md:gap-4 cursor-pointer border border-transparent hover:border-terracotta/20 transition-colors" data-id="element-125">
              <CheckCircle2 className="text-terracotta shrink-0 mt-1" size={24} data-id="element-126" />
              <div data-id="element-127">
                <h3 className="font-serif font-bold text-brown text-lg md:text-xl mb-1 md:mb-2" data-id="element-128">
                  {target.title}
                </h3>
                <p className="font-sans text-sm md:text-base text-brown/70" data-id="element-129">
                  {target.desc}
                </p>
              </div>
            </motion.div>)}
        </div>

        <div className="text-center" data-id="element-130">
          <p className="font-sans text-brown/60 text-xs md:text-sm" data-id="element-131">
            ¿No están seguros si es para ustedes? Tienen 7 días de garantía →
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mt-8 md:mt-12 flex justify-center" data-id="element-132">
          <img src="https://cdn.magicpatterns.com/uploads/jPwQwMsLvZ9Tc9R8naJtr7/92fc2599-f4dd-4215-930a-7a13000c27d4.png" alt="Los 9 meses más importantes, en equipo — recorrido mes a mes con el libro 'El equipo que somos'" loading="lazy" decoding="async" className="w-full max-w-md h-auto rounded-2xl shadow-md" data-id="element-133" />
        </motion.div>
      </div>
    </section>;
}